import * as React from 'react';

const marketingSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <g style={{ mixBlendMode: 'multiply' }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75748 17.674C8.98331 17.7102 9.18182 17.5311 9.18182 17.3023V15.9318C9.18182 15.7059 9.36497 15.5227 9.59091 15.5227H10.4091C10.635 15.5227 10.8182 15.7059 10.8182 15.9318V17.3023C10.8182 17.5311 11.0167 17.7102 11.2425 17.674C14.5401 17.1442 17.1442 14.5401 17.674 11.2425C17.7102 11.0167 17.5311 10.8182 17.3023 10.8182H15.9318C15.7059 10.8182 15.5227 10.635 15.5227 10.4091V9.59091C15.5227 9.36497 15.7059 9.18182 15.9318 9.18182H17.3023C17.5311 9.18182 17.7102 8.98331 17.674 8.75748C17.1442 5.45993 14.5401 2.85584 11.2425 2.32605C11.0167 2.28977 10.8182 2.46894 10.8182 2.69766V4.06818C10.8182 4.29412 10.635 4.47727 10.4091 4.47727H9.59091C9.36497 4.47727 9.18182 4.29412 9.18182 4.06818V2.69766C9.18182 2.46894 8.98331 2.28977 8.75748 2.32605C5.45993 2.85584 2.85584 5.45992 2.32605 8.75748C2.28977 8.98331 2.46894 9.18182 2.69766 9.18182H4.06818C4.29412 9.18182 4.47727 9.36497 4.47727 9.59091V10.4091C4.47727 10.635 4.29412 10.8182 4.06818 10.8182H2.69766C2.46894 10.8182 2.28977 11.0167 2.32605 11.2425C2.85584 14.5401 5.45992 17.1442 8.75748 17.674ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        fill="url(#paint0_linear_23086_12513)"
      />
    </g>
    <mask
      id="mask0_23086_12513"
      maskUnits="userSpaceOnUse"
      x="5"
      y="5"
      width="10"
      height="10"
    >
      <path
        d="M5.90918 8.12442V11.8628C5.90918 12.2288 6.10479 12.5669 6.42211 12.7494L9.49029 14.5136C9.80593 14.6951 10.1943 14.6951 10.5099 14.5136L13.5781 12.7494C13.8954 12.5669 14.091 12.2288 14.091 11.8628V8.12442C14.091 7.76518 13.9025 7.43227 13.5945 7.24744L10.5263 5.40653C10.2024 5.21221 9.79778 5.21221 9.4739 5.40653L6.40572 7.24744C6.09767 7.43227 5.90918 7.76518 5.90918 8.12442Z"
        fill="#D9D9D9"
        stroke="black"
        strokeWidth="0.204545"
      />
    </mask>
    <g mask="url(#mask0_23086_12513)">
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M5.90918 7.44312L10.0001 9.89766V14.8068L5.90918 12.4545V7.44312Z"
          fill="url(#paint1_linear_23086_12513)"
        />
      </g>
      <path
        d="M14.0911 7.44312L10.0002 9.89766V14.8068L14.0911 12.4545V7.44312Z"
        fill="url(#paint2_linear_23086_12513)"
      />
      <path
        d="M10.0002 5.09082L6.01152 7.54537L10.0002 9.89764L14.0911 7.54537L10.0002 5.09082Z"
        fill="url(#paint3_linear_23086_12513)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_23086_12513"
        x1="14.2353"
        y1="14.2857"
        x2="-9.08262"
        y2="0.136145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23086_12513"
        x1="8.0821"
        y1="9.28402"
        x2="12.9213"
        y2="15.3331"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7DC4FF" />
        <stop offset="1" stopColor="#FFE7AB" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23086_12513"
        x1="4.98879"
        y1="13.6818"
        x2="13.2543"
        y2="15.313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_23086_12513"
        x1="7.28329"
        y1="9.16099"
        x2="15.2256"
        y2="3.9426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default marketingSmall;
